<script lang="ts">
	import { Line } from '@repo/ui'

	interface Props {
		menu?: boolean
	}

	let { menu = false }: Props = $props()
</script>

<div class={menu ? 'mx-3 my-1' : 'my-3'}>
	<Line />
</div>
